<div class="col-sm-12 p-4">
    <div class=" m-0">
        <div class="container-fluid">
            <div class="row">
                <div>
                    <div class="row">
                        <div class="row col-12">
                            <div class="row col-12">
                                <div class="card">

                                    <div class="card-body">
                                        <table class="table table-striped mt-3">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th scope="col">{{'Recivers' | translate }}</th>
                                                    <th scope="col">{{'OffenderType' | translate }}</th>
                                                    <th scope="col">{{'Description' | translate }}</th>
                                                    <th scope="col">{{ "PenaltyTitle" | translate }}</th>
                                                    <th scope="col">{{ "SadadNumber" | translate }}</th>
                                                    <th scope="col">{{ "PenaltyAmount" | translate }}</th>
                                                    <th scope="col">{{'SadadStatus' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of CasePenaltiesList">



                                                    <td>
                                                        {{ item.memberName }}
                                                    </td>
                                                    <td>
                                                        {{item.memberTypeName}}
                                                    </td>

                                                    <td>
                                                        <p style="margin-bottom: 0;"><span
                                                                style="font-weight: bold;">وصف العقوبة</span> {{
                                                            item.description }}</p>
                                                        <p><span style="font-weight: bold;">{{'Violation' | translate
                                                                }}</span> {{ item.violationName }}</p>
                                                    </td>
                                                    <td>{{ item.penaltyTitle }} - {{item.isFinancial?"مالية":"ادارية"}}
                                                    </td>
                                                    <td>{{ item.sadadNumber }}</td>
                                                    <td *ngIf="item.amount==0"> __ </td>
                                                    <td *ngIf="item.amount!=0">{{ item.amount }}</td>

                                                    <td>{{ item.isFinancial? item.invoiceStatusName : "-" }}</td>


                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>